module.exports = __webpack_public_path__ + "static/media/Logo.aa8d7e82.png";